export default "__VITE_ASSET__D3Oy_DN2__"